import { createNgReactBridgeDirective } from '../../react-bridge'
import { ApplicationReportsButton } from '../../../components/application-reports'

export const applicationReportsButton = createNgReactBridgeDirective(
  'reactApplicationReportsButton',
  [],
  ApplicationReportsButton,
  [
    'isFreemium',
    'organizationID',
    'applicationID',
    'onVulnTrendClick',
    'onPDFClick',
    'isAppUnlicensed'
  ]
)
